export default function calculateAddOnGiftAmount(
  primaryGiftAmount,
  addOnGiftAmounts,
  { type, presetAmount, percentage, addOnID },
  ctfData,
  paymentMethodType
) {
  if (type === "flat") return presetAmount;
  if (type === "percentage") {
    if (!primaryGiftAmount || !percentage) return 0;
    return primaryGiftAmount * percentage;
  }
  if (type === "ctf") {
    if (!primaryGiftAmount) return 0;
    if (!primaryGiftAmount && !addOnGiftAmounts?.length) return 0;
    let donationAmount = parseFloat(primaryGiftAmount || 0);
    addOnGiftAmounts.forEach((a) => {
      if (a.addOnID !== addOnID && a.isChecked)
        donationAmount += parseFloat(a.amount || 0);
    });
    const feePercentage =
      paymentMethodType === "bank" || paymentMethodType === "bank_account"
        ? ctfData.ach_processing_fee_percent
        : ctfData.cc_processing_fee_percent;
    return (
      (donationAmount + ctfData.per_transaction_fee_amt / 100) /
        (1 - feePercentage) -
      donationAmount
    );
  }
}
